import * as React from "react";
import { useState } from "react";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { Alert, Button, Modal } from "components/bootstrap";
import { ModalSubmit, Spinner } from "components/common";
import { getCredentialsDefinition } from "data-tiering/repository-credentials";
import { getRepositoryTypeLabel } from "data-tiering/repository-management/types";
import useRepositoryCredentials from "./hooks/useRepositoryCredentials";
const EditCredentialsModal = ({ repositoryName, repositoryType, onClose }) => {
  const { t } = useTranslation("enterprise_data_tiering");
  const definition = getCredentialsDefinition(repositoryType);
  const { credentials, onUpdateCredentials } = useRepositoryCredentials(repositoryName);
  const [verificationError, setVerificationError] = useState(null);
  const handleSubmit = (payload, { setErrors }) => {
    setVerificationError(null);
    return onUpdateCredentials(payload).then(() => onClose()).catch((error) => {
      var _a, _b;
      const body = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.body;
      if ((error == null ? void 0 : error.status) === 400 && (body == null ? void 0 : body.failed) && (body == null ? void 0 : body.errors)) {
        const { verification, ...fieldErrors } = body.errors;
        setErrors(
          Object.fromEntries(Object.entries(fieldErrors).map(([field, messages]) => [field, messages.join(" ")]))
        );
        if (verification) {
          setVerificationError(verification.join(" "));
        }
      } else {
        setVerificationError((_b = body == null ? void 0 : body.message) != null ? _b : String(error));
      }
    });
  };
  const modalContent = () => {
    var _a, _b, _c, _d;
    if (!definition) {
      return null;
    }
    if (credentials.isLoading) {
      return /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(Spinner, { text: t("edit_credentials.loading") }));
    }
    if (credentials.error) {
      const body = (_b = (_a = credentials.error) == null ? void 0 : _a.additional) == null ? void 0 : _b.body;
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: t("edit_credentials.load_failed_title") }, (_c = body == null ? void 0 : body.message) != null ? _c : String(credentials.error))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(Button, { onClick: onClose }, t("common:actions.close"))));
    }
    const { edit } = definition;
    const { Fields } = edit;
    const record = (_d = credentials.data) != null ? _d : null;
    return /* @__PURE__ */ React.createElement(
      Formik,
      {
        initialValues: edit.initialValues(record),
        validate: edit.validate,
        onSubmit: (values, helpers) => handleSubmit(edit.toPayload(values), helpers)
      },
      ({ isSubmitting, isValidating, isValid }) => /* @__PURE__ */ React.createElement(Form, { className: "form form-horizontal" }, /* @__PURE__ */ React.createElement(Modal.Body, null, verificationError && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: t("edit_credentials.verification_failed_title") }, verificationError), /* @__PURE__ */ React.createElement(Fields, { record })), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
        ModalSubmit,
        {
          submitButtonText: t("edit_credentials.save"),
          submitLoadingText: t("edit_credentials.verifying"),
          onCancel: onClose,
          disabledSubmit: isValidating || !isValid,
          isSubmitting
        }
      )))
    );
  };
  return /* @__PURE__ */ React.createElement(Modal, { show: true, bsSize: "large", onHide: onClose }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, t("edit_credentials.title", { type: getRepositoryTypeLabel(repositoryType), name: repositoryName }))), modalContent());
};
export default EditCredentialsModal;
